import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SUBDOMAIN_SLUGS, subdomainConfigs } from "@/subdomains/configs";

export default function SubdomainIndex() {
  return (
    <div data-testid="subdomain-index" className="min-h-screen bg-zinc-50">
      <div className="max-w-5xl mx-auto px-6 py-16 lg:py-24">
        <div className="mb-12">
          <Link to="/" className="text-sm text-zinc-500 hover:text-zinc-800 transition-colors">
            ← Back to Bizlem.com
          </Link>
          <h1 className="mt-6 text-4xl font-black tracking-tight text-zinc-900">Subdomain Previews</h1>
          <p className="mt-4 text-zinc-600 max-w-2xl">
            Preview the 7 Bizlem product subdomains. SmartCampus is hosted separately at{" "}
            <a
              href="https://smartcampus.bizlem.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              smartcampus.bizlem.com
            </a>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SUBDOMAIN_SLUGS.map((slug) => {
            const config = subdomainConfigs[slug];
            const Icon = config.icon;
            return (
              <Link
                key={slug}
                to={`/sites/${slug}`}
                data-testid={`subdomain-preview-link-${slug}`}
                className={`group relative border border-zinc-200 bg-white p-6 hover:shadow-lg transition-all ${config.theme.tint}`}
              >
                <div className="flex items-start justify-between gap-4">
                  <div className={`w-11 h-11 rounded-xl ${config.theme.primary} flex items-center justify-center`}>
                    <Icon size={22} weight="fill" className="text-white" />
                  </div>
                  <ArrowUpRight
                    size={18}
                    className="text-zinc-400 group-hover:text-zinc-700 transition-colors"
                  />
                </div>
                <h2 className="mt-4 text-lg font-bold text-zinc-900">{config.name}</h2>
                <p className="mt-1 text-xs font-mono text-zinc-500">{config.host}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
